import axios from "axios";

// Define the structure of the payload
interface ContextPayload {
    [key: string]: any;
}

// Define the response types
interface CallBBCardResponse {
    [key: string]: any;
}

interface VoiceBBCardResponse {
    bbcId: string;
    [key: string]: any;
}

interface EndVoiceBBCardResponse {
    [key: string]: any;
}

// Function to create a baseball crypt request
export const callBBCard = async (payload: ContextPayload): Promise<CallBBCardResponse | null> => {
    try {
        const { data } = await axios.post<CallBBCardResponse>(
            `${process.env.REACT_APP_CHATCON_URL}/baseball-create-crypt-request`,
            {
                contextParameters: payload
            }
        );

        return data || null;
    } catch (e) {
        console.error("Error in callBBCard:", e);
        return null;
    }
};

// Function to create a voice crypt request
export const voiceBBCard = async (payload: ContextPayload): Promise<string | null> => {
    try {
        const { data } = await axios.post<VoiceBBCardResponse>(
            `${process.env.REACT_APP_CHATCON_URL}/baseball-voice-create-crypt-request`,
            {
                contextParameters: payload
            }
        );

        return data?.bbcId || null;
    } catch (e) {
        console.error("Error in voiceBBCard:", e);
        return null;
    }
};

// Function to end a voice crypt request
export const endVoiceBBCard = async (payload: ContextPayload): Promise<EndVoiceBBCardResponse | null> => {
    try {
        const { data } = await axios.post<EndVoiceBBCardResponse>(
            `${process.env.REACT_APP_CHATCON_URL}/baseball-voice-end-crypt-request`,
            payload,
            {
                headers: {
                    "X-API-KEY": "AIzaSyCjycAkPA1Tlyrv-6nSuyql0WnnB5W84tA",
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                },
            }
        );

        return data || null;
    } catch (e) {
        console.error("Error in endVoiceBBCard:", e);
        return null;
    }
};
